import { render, staticRenderFns } from "./InitialNursingReview.vue?vue&type=template&id=2ab72550&"
import script from "./InitialNursingReview.vue?vue&type=script&lang=js&"
export * from "./InitialNursingReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports